import PropTypes from "prop-types";
import { Box, Divider, Drawer, Typography, useMediaQuery } from "@mui/material";
import { APP_VERSION } from "../../constants/apiConstants";
import HomeIcon from "@mui/icons-material/Home";
import GroupIcon from "@mui/icons-material/Group";
import SettingsIcon from "@mui/icons-material/Settings";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import { NavItem } from "../nav-item";
import { IconNavItem } from "../icon-nav-item";
import { Isotipo } from "../../assets/isotipo";
import { Isologotipo } from "../../assets/isoLogotipo";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import Tooltip from "@mui/material/Tooltip";
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';

const items = [
  {
    href: "/home",
    icon: <HomeIcon fontSize="small" />,
    title: "Inicio",
    key: "home",
  },
  {
    href: "/configuration",
    icon: <SettingsIcon fontSize="small" />,
    title: "Configuración",
    key: "configuration",
  },
  {
    href: "/users",
    icon: <GroupIcon fontSize="small" />,
    title: "Usuarios",
    key: "users",
  },
  {
    href: "/documentacion",
    icon: <IntegrationInstructionsIcon fontSize="small" />,
    title: "Documentación",
    key: "documentacion",
  },
  {
    href: "/medical-staff",
    icon: <MedicalServicesIcon fontSize="small" />,
    title: "Admin. de médicos",
    key: "medical-staff",
  },
  {
    href: "/logs",
    icon: <WorkHistoryIcon fontSize="small" />,
    title: "Visualización de Logs",
    key: "logs",
  },
];

const excludeKeysRole2 = ["users", "documentacion", "configuration", "home", "logs" ];
const excludeKeysRole3 = ["users", "documentacion", "configuration", "home", "medical-staff"];

export const PageSidebar = (props) => {
  const { open, openPersistent, onClose, role } = props;
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"), {
    defaultMatches: true,
    noSsr: false,
  });

  let filteredItems = [];
  if (Number(role) === 1) {
    filteredItems = items;
  } else if (Number(role) === 2)  {
    filteredItems = items.filter((item) => !excludeKeysRole2.includes(item.key));
  } else if (Number(role) === 3) {
    filteredItems = items.filter((item) => !excludeKeysRole3.includes(item.key));
  }

  const content = (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100%",
          textAlign: "center",
        }}
      >
        <div>
          <Box sx={{ px: 2, pt: 3 }}>
            {!openPersistent ? (
              <Isotipo
              sx={{
                height: 32,
                width: 32,
              }}
              variant={"light"}
            />
            ) : (
              <Box
              sx={{
                alignItems: "center",
                backgroundColor: "rgba(255, 255, 255, 0.04)",
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
                px: 2,
                py: "11px",
                borderRadius: 1,
              }}
            >
              <Isologotipo
                sx={{
                  height: 34,
                  width: 34,
                }}
                variant={"light"}
              />
            </Box>
            )}
          </Box>
        </div>
        <Divider
          sx={{
            borderColor: "#2D3748",
            my: 3,
          }}
        />
        <Box sx={{ flexGrow: 1 }}>
          {filteredItems.map((item, index) =>
            openPersistent ? (
              <NavItem
                key={index}
                icon={item.icon}
                href={item.href}
                title={item.title}
              />
            ) : (
              <Tooltip title={item.title} placement="right">
                <div>
                  <IconNavItem
                    key={index}
                    icon={item.icon}
                    href={item.href}
                    title={item.title}
                  />
                </div>
              </Tooltip>
            )
          )}
        </Box>
        <Divider sx={{ borderColor: "#2D3748" }} />
        <Box sx={{ py: 2, textAlign: "center" }}>
          <Typography variant="caption" sx={{ color: "neutral.400" }}>
            {openPersistent ? `Versión ${APP_VERSION}` : APP_VERSION}
          </Typography>
        </Box>
      </Box>
    </>
  );

  const contentMobile = (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100%",
        }}
      >
        <div>
          <Box sx={{ px: 2, pt: 2 }}>
          {openPersistent ? (
              <Isotipo
              sx={{
                height: 32,
                width: 32,
              }}
              variant={"light"}
            />
            ) : (
              <Box
              sx={{
                alignItems: "center",
                backgroundColor: "rgba(255, 255, 255, 0.04)",
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
                px: 2,
                py: "11px",
                borderRadius: 1,
              }}
            >
              <Isologotipo/>
              {/* <div>
                <Typography
                  color="inherit"
                  variant="subtitle1"
                >
                  Backoffice
                </Typography>
                <Typography
                  color="neutral.400"
                  variant="subtitle1"
                  sx={{ fontSize: "0.85rem" }}
                >
                  Botón de prescripción
                </Typography>
              </div> */}
            </Box>
            )}
          </Box>
        </div>
        <Divider
          sx={{
            borderColor: "#2D3748",
            my: 3,
          }}
        />
        <Box sx={{ flexGrow: 1 }}>
          {filteredItems.map((item, index) => (
            <NavItem
              key={index}
              icon={item.icon}
              href={item.href}
              title={item.title}
            />
          ))}
        </Box>
        <Divider sx={{ borderColor: "#2D3748" }} />
        <Box sx={{ py: 2, textAlign: "center" }}>
          <Typography variant="caption" sx={{ color: "neutral.400" }}>
            {`Versión ${APP_VERSION}`}
          </Typography>
        </Box>
      </Box>
    </>
  );

  if (lgUp) {
    return (
      <Drawer
        anchor="left"
        open={open}
        PaperProps={{
          sx: openPersistent
            ? {
                backgroundColor: "neutral.900",
                color: "#FFFFFF",
                width: 280,
              }
            : {
                backgroundColor: "neutral.900",
                color: "#FFFFFF",
              },
        }}
        variant="permanent"
      >
        {content}
      </Drawer>
    );
  }
  
  return (
    <Drawer
      anchor="left"
      onClose={onClose}
      open={open}
      PaperProps={{
        sx: {
          backgroundColor: "neutral.900",
          color: "#FFFFFF",
          width: 280,
        },
      }}
      sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
      variant="temporary"
    >
      {contentMobile}
    </Drawer>
  );
};

PageSidebar.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

